/* ==========================================================================
   「天国への手紙」専用スクリプト
   ==========================================================================
   ・このページ専用です。theme.liquid には手を入れていません。
   ・外部との通信は「手紙を預ける」「公開された手紙を読み込む」の2つだけで、
     いずれも fetch（JSON）です。画面遷移は発生しないため、お客様には
     別サービスに移動したようには見えません。
   ・手紙の本文を画面に入れるときは必ず textContent を使います。
     innerHTML は一切使いません（XSS対策）。
   ・Cloudflare Turnstile（Bot対策）は、フォームが画面に入ってから
     読み込みます。ページ表示の速度に影響しないようにするためです。

   テーマ載せ替え時は assets/lumiere-letter.css / .js と
   sections/lumiere-letter-*.liquid を一式で移してください。
   ========================================================================== */

(function () {
  'use strict';

  // 同じファイルが二重に読み込まれても処理が重複しないようにする
  if (window.__lumiereLetterLoaded) return;
  window.__lumiereLetterLoaded = true;

  var GENERIC_ERROR =
    '申し訳ございません。ただいま受け付けができませんでした。' +
    'お手数ですが、少し時間をおいてからお試しください。';

  /* ======================================================================
     投稿フォーム
     ====================================================================== */
  function initForm() {
    var form = document.getElementById('lth-form');
    if (!form) return;

    var api = form.dataset.api;
    var siteKey = form.dataset.siteKey;
    var maxLen = parseInt(form.dataset.maxLength, 10) || 1000;

    var bodyEl = document.getElementById('lth-body');
    var counter = document.getElementById('lth-counter');
    var errorBox = document.getElementById('lth-error');
    var submitBtn = document.getElementById('lth-submit');
    var veil = document.getElementById('lth-veil');
    var paperTo = document.getElementById('lth-paper-to');
    var care = document.getElementById('lth-care');
    var otherInput = document.getElementById('lth-to-other');

    var formToken = null;        // CSRF対策の合鍵（サーバーが発行）
    var openedAt = Date.now();   // フォームを見始めた時刻（Bot判定に使用）
    var turnstileId = null;
    var turnstileLoading = false;
    var sending = false;

    /* ---------- 文字数カウンター ---------- */
    if (bodyEl && counter) {
      bodyEl.addEventListener('input', function () {
        var n = bodyEl.value.length;
        counter.textContent = n + ' / ' + maxLen + ' 文字';
        counter.className = 'lth-counter' + (n > maxLen ? ' is-over' : '');
      });
    }

    /* ---------- 「その他」を選んだときだけ自由入力を出す ---------- */
    var toChips = document.getElementById('lth-chips-to');
    if (toChips && otherInput) {
      toChips.addEventListener('change', function (ev) {
        var isOther = ev.target && ev.target.value === 'その他';
        otherInput.hidden = !isOther;
        if (isOther) otherInput.focus();
      });
    }

    /* ---------- 公開設定の選択を見た目に反映 ---------- */
    var radios = form.querySelectorAll('.lth-radio input[type="radio"]');
    function syncRadios() {
      Array.prototype.forEach.call(radios, function (r) {
        var row = r.closest('.lth-radio');
        if (row) row.classList.toggle('is-on', r.checked);
      });
    }
    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', syncRadios);
    });
    syncRadios();

    /* ---------- サーバーから合鍵を取得 ---------- */
    function fetchToken() {
      return fetch(api + '/api/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (d) { formToken = d.token; })
        .catch(function () { /* 送信時にもう一度試します */ });
    }

    /* ---------- Turnstile（Bot対策）の読み込み ---------- */
    function loadTurnstile() {
      if (turnstileLoading || !siteKey) return;
      turnstileLoading = true;

      window.lthTurnstileReady = function () {
        try {
          turnstileId = window.turnstile.render('#lth-captcha', {
            sitekey: siteKey,
            language: 'ja',
            theme: 'light',
          });
        } catch (e) { /* 表示できない環境では送信時に案内します */ }
      };

      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=lthTurnstileReady&render=explicit';
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    }

    /**
     * 合鍵とBot対策の準備。
     * 以前はフォームが画面に入ってから読み込んでいましたが、
     * スクロールしてすぐ送信された場合に確認が間に合わなかったため、
     * ページの表示が落ち着いた時点で準備するようにしています。
     */
    function prepare() {
      fetchToken();
      loadTurnstile();
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prepare, { timeout: 1500 });
    } else {
      setTimeout(prepare, 500);
    }

    /** Bot対策の確認が終わるのを待つ（最大 waitMs ミリ秒） */
    function waitForCaptcha(waitMs) {
      return new Promise(function (resolve) {
        var started = Date.now();
        (function poll() {
          var t = '';
          try {
            t = (window.turnstile && turnstileId !== null)
              ? window.turnstile.getResponse(turnstileId) : '';
          } catch (e) { t = ''; }

          if (t) return resolve(t);
          if (Date.now() - started > waitMs) return resolve('');
          setTimeout(poll, 300);
        })();
      });
    }

    /* ---------- エラー表示（責める言い方はしません） ---------- */
    function showError(message) {
      if (!errorBox) { alert(message); return; }
      errorBox.textContent = message;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function clearError() {
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    }

    /* ======================================================================
       送信演出

       ボタンを押した「その場で」手紙が昇り始めます。
       サーバーとのやりとりはその裏側で進めるので、
       待っているあいだも画面が止まって見えません。

         1. 手紙がゆっくり上へ → 少し透明に → 光になって消える（約2.2秒）
         2. お預かりの手続き中は、光の粒が静かに昇り続ける
         3. 手続きが終わったら「手紙をお預かりしました。」

       うまく届けられなかったときは、静かに元の画面に戻します。
       ====================================================================== */
    var animStartedAt = 0;
    var waitTimer = null;

    /** 1〜2：手紙が昇り、光の粒が昇り続ける */
    function startAnimation(toLabel) {
      if (paperTo) paperTo.textContent = toLabel + 'へ';
      if (care) care.hidden = true;

      // 手紙が消える瞬間に散る光
      Array.prototype.forEach.call(veil.querySelectorAll('.lth-spark'), function (el) {
        el.parentNode.removeChild(el);
      });
      for (var i = 0; i < 7; i++) {
        var sp = document.createElement('span');
        sp.className = 'lth-spark';
        sp.style.left = (44 + Math.random() * 12) + '%';
        sp.style.top = (46 + Math.random() * 10) + '%';
        sp.style.animationDelay = (0.5 + Math.random() * 0.7) + 's';
        veil.appendChild(sp);
      }

      veil.classList.remove('is-done', 'is-waiting');
      veil.classList.add('is-on');
      document.body.style.overflow = 'hidden';
      animStartedAt = Date.now();

      // 紙飛行機が見えなくなったら、待っているあいだの光に切り替える
      // （CSS の演出：折りたたみ 0〜1.0秒／虹 0.4〜2.4秒／飛行 1.3〜4.3秒）
      //
      // ★ 「アニメーションを減らす」設定の方も同じ時間にしています。
      //    以前はここで演出を飛ばしていたため、紙飛行機が
      //    見えないまま終わってしまっていました。
      clearTimeout(waitTimer);
      waitTimer = setTimeout(function () {
        veil.classList.add('is-waiting');
      }, 4500);
    }

    /** 3：お預かり完了。演出が短すぎないよう、最低の時間は見せる */
    function finishAnimation(showCare) {
      var minMs = 5000;
      var rest = Math.max(0, minMs - (Date.now() - animStartedAt));

      setTimeout(function () {
        clearTimeout(waitTimer);
        if (care) care.hidden = !showCare;
        veil.classList.remove('is-waiting');
        veil.classList.add('is-done');
      }, rest);
    }

    /** 届けられなかったとき：静かに元の画面へ戻す */
    function abortAnimation() {
      clearTimeout(waitTimer);
      veil.classList.remove('is-on', 'is-waiting', 'is-done');
      document.body.style.overflow = '';
    }

    var closeBtn = document.getElementById('lth-veil-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        veil.classList.remove('is-on', 'is-done');
        document.body.style.overflow = '';
        form.reset();
        if (otherInput) otherInput.hidden = true;
        if (counter) counter.textContent = '0 / ' + maxLen + ' 文字';
        syncRadios();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* ---------- 送信 ---------- */
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (sending) return;
      clearError();

      var to = form.querySelector('input[name="recipient"]:checked');
      var feel = form.querySelector('input[name="feeling"]:checked');

      if (!to) { showError('「誰への手紙ですか？」をお選びください。'); return; }
      if (!feel) { showError('「どんなことを伝えたいですか？」をお選びください。'); return; }
      if (!bodyEl.value.trim()) {
        showError('手紙の本文をご記入ください。');
        bodyEl.focus();
        return;
      }
      if (bodyEl.value.length > maxLen) {
        showError('本文は' + maxLen + '文字以内でご記入ください。');
        return;
      }

      sending = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'お預かりしています…';

      // ★ ボタンを押したその場で、手紙が空へ昇り始めます。
      //   サーバーとのやりとりはこの裏で進みます。
      startAnimation(to.value);

      /**
       * Bot対策の確認と合鍵をそろえてから送ります。
       * まだ終わっていなければ最大12秒待つので、お客様がボタンを
       * 押し直す必要はありません。
       */
      if (siteKey) loadTurnstile();

      Promise.all([
        siteKey ? waitForCaptcha(12000) : Promise.resolve(''),
        formToken ? Promise.resolve() : fetchToken(),
      ]).then(function (results) {
        var captchaToken = results[0];

        if (siteKey && !captchaToken) {
          abortAnimation();
          showError('確認に時間がかかっています。'
            + 'お手数ですが、ページを再読み込みしてからもう一度お試しください。');
          return Promise.reject('captcha');
        }

        var payload = {
          token: formToken,
          turnstile_token: captchaToken,
          recipient: to.value,
          recipient_other: otherInput ? otherInput.value : '',
          feeling: feel.value,
          nickname: (document.getElementById('lth-nickname') || {}).value || '',
          body: bodyEl.value,
          wants_public: (form.querySelector('input[name="wants_public"]:checked') || {}).value || '0',
          website: (document.getElementById('lth-hp') || {}).value || '',  // ハニーポット
          dwell_ms: Date.now() - openedAt,
        };

        return fetch(api + '/api/letters', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      })
        .then(function (r) {
          return r.json().then(function (d) { return { status: r.status, data: d }; });
        })
        .then(function (res) {
          if (res.data && res.data.ok) {
            finishAnimation(res.data.care === true);
          } else {
            abortAnimation();
            showError((res.data && res.data.message) || GENERIC_ERROR);
          }
        })
        .catch(function (err) {
          // 'captcha' のときは上で案内済みなので、重ねて表示しない
          if (err !== 'captcha') {
            abortAnimation();
            showError(GENERIC_ERROR);
          }
        })
        .then(function () {
          sending = false;
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || '天国へ届ける';
          // 合鍵は1回使うごとに新しくする
          formToken = null;
          fetchToken();
          if (window.turnstile && turnstileId !== null) {
            try { window.turnstile.reset(turnstileId); } catch (e) {}
          }
        });
    });
  }

  /* ======================================================================
     公開された手紙の一覧
     ====================================================================== */
  function initList() {
    var root = document.getElementById('lth-list');
    if (!root) return;

    var api = root.dataset.api;
    var pageSize = parseInt(root.dataset.pageSize, 10) || 6;
    var grid = document.getElementById('lth-grid');
    var moreBtn = document.getElementById('lth-load-more');
    var cursor = null;
    var loading = false;

    function card(L) {
      var article = document.createElement('article');
      article.className = 'lth-letter';

      var to = document.createElement('p');
      to.className = 'lth-letter-to';
      to.textContent = L.to + 'へ';
      article.appendChild(to);

      if (L.feeling) {
        var tag = document.createElement('span');
        tag.className = 'lth-letter-tag';
        tag.textContent = L.feeling;
        article.appendChild(tag);
      }

      var body = document.createElement('p');
      body.className = 'lth-letter-body is-clamped';
      body.textContent = L.body;          // ← HTMLとして解釈させない
      article.appendChild(body);

      // 長い手紙はカードの中で開きます（詳細ページは作りません）
      if (L.body && L.body.length > 120) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'lth-more';
        more.textContent = 'つづきを読む';
        more.addEventListener('click', function () {
          var clamped = body.classList.toggle('is-clamped');
          more.textContent = clamped ? 'つづきを読む' : '閉じる';
        });
        article.appendChild(more);
      }

      var meta = document.createElement('div');
      meta.className = 'lth-letter-meta';
      var name = document.createElement('span');
      name.textContent = L.name ? L.name : '名前のない手紙';
      meta.appendChild(name);
      // 投稿日は表示しません（投稿がまばらで古く見えるため）。APIは L.date を返し続けます
      article.appendChild(meta);

      return article;
    }

    function load(first) {
      if (loading) return;
      loading = true;
      if (moreBtn) moreBtn.disabled = true;

      var url = api + '/api/letters?limit=' + pageSize + (cursor ? '&cursor=' + encodeURIComponent(cursor) : '');

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (first) grid.textContent = '';   // 読み込み中の枠を消す

          if (!d || !d.ok) throw new Error('bad response');

          if (first && (!d.letters || d.letters.length === 0)) {
            var empty = document.createElement('p');
            empty.className = 'lth-empty';
            empty.textContent =
              'ただいま掲載できるお手紙をご用意しております。\nもう少しお待ちください。';
            grid.appendChild(empty);
            if (moreBtn) moreBtn.hidden = true;
            return;
          }

          d.letters.forEach(function (L) { grid.appendChild(card(L)); });
          cursor = d.next_cursor;

          if (moreBtn) {
            if (cursor) {
              moreBtn.disabled = false;
            } else {
              moreBtn.hidden = true;
            }
          }
        })
        .catch(function () {
          // 取得できないときは静かに隠します（エラー文で世界観を壊さないため）
          if (first) {
            grid.textContent = '';
            if (moreBtn) moreBtn.hidden = true;
          } else if (moreBtn) {
            moreBtn.disabled = false;
          }
        })
        .then(function () { loading = false; });
    }

    if (moreBtn) moreBtn.addEventListener('click', function () { load(false); });

    // 一覧が画面に近づいてから読み込む（表示速度への影響を抑えます）
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          load(true);
        }
      }, { rootMargin: '300px' });
      io.observe(root);
    } else {
      load(true);
    }
  }

  /* ---------------------------------------------------------------------- */
  function boot() {
    initForm();
    initList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
